import React from "react";
import "./Projects.css";

import { Link } from "react-router-dom";
import { ImGithub } from "react-icons/im";
import { FaEye } from "react-icons/fa";


const Projects = () => {
  return (
    <>
      <section className="projectIntro">
        <h2>My Projects</h2>
        <p>
          Here are some projects that I created. The first one is what happens if 
          you only want to test some functions on a rainy Sunday but get carried
          away and have to make it look nice too! The second one is my first React
          project. It's an app that provides the weather for two cities, Amsterdam
          and Montreal. Next up is some fun with CSS-only particles. The fourth one 
          is my first React/Redux webshop. It 'sells' eggwarmers. 
          More to come in the future...
        </p>
      </section>
      <section className="projectDisplay">
        <div className="projectScreen">
        
          <div className="projectText">
          <h2>Fun with React</h2>
            <p>Font-size buttons and slider</p>
            <p></p>
            <a href="https://github.com/LeontineC/pastel-react"><ImGithub className='linksProjectGithub'/></a>
            {/* <Link to="/neon" className="linksProject"> */}
              {/* <FaEye /> */}
            {/* </Link> */}
            <a
              href="https://leontinec.github.io/pastel-react/"
              className="linksProject"
            >
              <FaEye />
            </a>
          </div>
        </div>
        <div className="projectScreen">
       
          <div className="projectText">
          <h2>React/ API</h2>
            <p>Weather App</p>
            <p></p>
            <a href="https://github.com/LeontineC/weather-app"><ImGithub className='linksProjectGithub'/></a>
            <a
              href="https://leontinec.github.io/weather-app/"
              className="linksProject"
            >
              <FaEye />
            </a>
          </div>
        </div>
        <div className="projectScreen">
        
          <div className="projectText">
          <h2>Fun with CSS</h2>
            <p>Animated Particles</p>
            <p></p>
            <a href="https://github.com/LeontineC/Projects/tree/main/Particles"><ImGithub className='linksProjectGithub'/></a>
            <Link to="/particles" className="linksProject">
            <FaEye />
            </Link>
          </div>
        </div>
        <div className="projectScreen">
        
          <div className="projectText">
          <h2>React/ Redux</h2>
            <p>Webshop</p>
            <p></p>
            <a href="https://github.com/LeontineC/webshop"><ImGithub className='linksProjectGithub'/></a>
            <a
              href="https://leontinec.github.io/webshop/"
              className="linksProject"
            >
              <FaEye />
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Projects;
